export default __webpack_public_path__ + "static/scores@768-a63129d4202aed8d917d02b390d71492.webp";